module.exports = __webpack_public_path__ + "media/images/education/SAPC5456-5ad730d21dd353e053578e902fcf33a5.png";